import { Button, Link, Pivot, PivotItem, PrimaryButton, ProgressIndicator, Stack } from '@fluentui/react';
import * as React from 'react';
import { isRegularExpressionLiteral } from 'typescript';
import { IUserListItem } from '../../../../Models/Admin/IUserListItem';
import { IInvoice } from '../../../../Models/Invoice/IInvoice';
import { IInvoiceItem } from '../../../../Models/Invoice/IInvoiceItem';
import { StornoStateEnum } from '../../../../Models/Invoice/StornoStateEnum';
import { formatUrl } from '../../../../Services/API/ApiHelpers';
import { backendUrl } from '../../../../Services/ConfigureService';
import { InvoiceDetail } from './InvoiceDetail';
import { InvoiceForm } from './InvoiceForm';
import { InvoiceItemList } from './InvoiceItemList';
import { InvoiceItemListView } from './InvoiceItemListView';

interface IInvoiceDetailViewProps {
    invoice?: IInvoice;
    onDismiss: () => void;
    isLoading: boolean;
    isReadOnly: boolean;
    isChanged: boolean;
    propertyChanged: (key: string, value: any) => void;
    findCustomer: (query: string) => Promise<IUserListItem[] | undefined>
    setCustomer: (customer: IUserListItem) => void;
    saveInvoice: (invoice?: IInvoice) => void;
    reload: () => void;
    sendViaEmail: (invoice: number) => void;
    createStorno: (invoiceId: number) => void;
    cancelStorno: (invoiceId: number) => void;
}


export const InvoiceDetailView: React.FunctionComponent<IInvoiceDetailViewProps> = (props) => {


    return (<Pivot aria-label="Akce">
        <PivotItem
            headerText="Obecné"
            headerButtonProps={{
                'data-order': 1,
                'data-title': 'Obecné',
            }}>

            <InvoiceForm
                
                setCustomer={props.setCustomer}
                createStorno={props.createStorno}
                cancelStorno={props.cancelStorno}
                findCustomer={props.findCustomer}
                isReadOnly={props.isReadOnly}
                isLoading={props.isLoading}
                invoice={props.invoice}
                propertyChanged={props.propertyChanged} />
            <Stack styles={{ root: { height: 10 } }}>
                {props.isLoading ? <ProgressIndicator /> : null}
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 20 }} horizontalAlign="center" styles={{ root: { paddingTop: 40 } }}>
                <PrimaryButton disabled={!props.isChanged} text="Uložit" onClick={() => props.saveInvoice(props.invoice)} />
                <Button text="Zrušit" onClick={props.onDismiss } />
            </Stack>
            {props.invoice && props.invoice?.id > 0 ?
                <Stack styles={{ root: { paddingTop: 30 } }} tokens={{ childrenGap: 10 }}>
                    <Link target="_black" href={formatUrl(backendUrl(), `/api/pdf/GetInvoice?invoiceId=` + props.invoice?.id)}>Vytisknout fakturu</Link>
                    <Link onClick={() => props.sendViaEmail(props.invoice?props.invoice.id:0)}>Odeslat emailem fakturu</Link>
                </Stack> : null}
        </PivotItem>
        {props.invoice?.id !== 0 ?
            <PivotItem
                headerText="Řádky faktury"
                headerButtonProps={{
                    'data-order': 1,
                    'data-title': 'Řádky faktury',
                }}>

                <InvoiceItemList isLoading={props.isLoading}
                    items={props.invoice?.items ? props.invoice.items : []}
                    isReadOnly={props.isReadOnly || props.invoice?.exported || props.invoice?.storno != StornoStateEnum.None}
                    invoiceId={props.invoice?.id ? props.invoice.id : 0}
                    reload={props.reload}
                />
            </PivotItem> : null}
        {props.invoice?.id !== 0 ?
        <PivotItem
            headerText="Platby"
            headerButtonProps={{
                'data-order': 1,
                'data-title': 'Obecné',
            }}>
        </PivotItem>: null}

    </Pivot>)
}
